import WarehouseRadio from './WarehouseRadio'

export default WarehouseRadio
